import translateNested from "app/pages/sales-intelligence/common-components/i18n/translateNested";
import { globalStringSanitizePipeline } from "app/pages/sales-intelligence/services/text-transform/stringTransformPipeline";
import { StyledSignalNameText } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/Signal/styles";
import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type UISignal from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignal";

import { StyledSignalName } from "../styles";

type Props = {
    uiSignal: Readonly<UISignal<SignalFilters>>;
    withTruncation?: boolean;
};

const SignalNamePlain = ({ uiSignal, withTruncation = false }: Props) => {
    const Component = withTruncation ? StyledSignalNameText : StyledSignalName;

    return (
        <Component data-automation="name-text">
            {globalStringSanitizePipeline.apply(translateNested(uiSignal.name))}
        </Component>
    );
};

export default SignalNamePlain;
